{
  "clear": "Kirkas",
  "invalid": "(epäkelpo)",
  "loading": "Ladataan...",
  "noResults": "Ei tuloksia"
}
